import { getFragmentData, type FragmentType } from '@packages/gql/generated/shopping';
import { ArticleServicesClusterFragmentFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesClusterFragmentFragmentDoc';
import type { ArticleServicesCurrencyFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesCurrencyFragmentDoc';
import { ArticleServiceFragmentDoc } from '@packages/gql/generated/shopping/ArticleServiceFragmentDoc';
import { Divider } from '@packages/shared/src/ui/Divider/Divider';
import { Fragment } from 'react';
import { ArticleService } from '../ArticleService/ArticleService.client';

/* GraphQL */ `
  fragment ArticleServicesClusterFragment on Cluster {
    label
    services {
      ...ArticleService
    }
  }
`;
export type ArticleServicesClusterProps = {
  data: FragmentType<typeof ArticleServicesClusterFragmentFragmentDoc>;
  /* should be in aPlus price value */
  currencyData: FragmentType<typeof ArticleServicesCurrencyFragmentDoc>;
  /** If true, the `ArticleService` will not have a divider below it */
  isLastCluster?: boolean;
};

export const ArticleServicesCluster = ({
  data,
  currencyData,
  isLastCluster,
}: ArticleServicesClusterProps) => {
  const { label, services } = getFragmentData(ArticleServicesClusterFragmentFragmentDoc, data);

  return (
    <fieldset>
      <legend className="text-size-body3 pt-1.5 pb-1 font-bold">{label}</legend>

      {services.map((service, idx) => {
        const { uuid } = getFragmentData(ArticleServiceFragmentDoc, service);
        return (
          <Fragment key={uuid}>
            <ArticleService data={service} currencyData={currencyData} />
            {isLastCluster && services.length - 1 === idx ? null : <Divider />}
          </Fragment>
        );
      })}
    </fieldset>
  );
};
